<template>
  <div class="cs-serviceItemList-container">
    <el-row v-for="index in itemCount" :key="index">
      <el-col :span="12" v-if="(index - 1) * 2 < totalCount">
        <span>{{ dataIn.itemList[(index - 1) * 2 ].name }}</span>
        <span
          >{{
            dataIn.itemList[(index - 1) * 2].price | toCurrency(dataIn.currency)
          }}</span
        >
      </el-col>
      <el-col :span="12" v-if="(index - 1) * 2 + 1 < totalCount">
        <span>{{ dataIn.itemList[(index - 1) * 2 + 1].name }}</span>
        <span
          >{{
            dataIn.itemList[(index - 1) * 2 + 1].price | toCurrency(dataIn.currency)
          }}</span
        >
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  props: {
    dataIn: {
      currency: Number,
      itemList: Array,
    },
  },
  data() {
    return {
      totalCount: 0,
      itemCount: 0,
    };
  },
  components: {},
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.itemList) {
        this.totalCount = this.dataIn.itemList.length;
       
        let count = parseInt(this.totalCount / 2);
        if (this.totalCount % 2 > 0){
          count ++;
        }
        this.itemCount = count;
      } else {
        this.itemCount = 0;
      }
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflow/serviceItemList.vue